// extracted by mini-css-extract-plugin
export default {"host":"CollapseHeader_host__fD7Qc"};